import { Container, Icon, Text, TextButton } from '@loomhq/lens';
import classnames from 'classnames';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  RECORD_VIDEO_CARD_KEY,
  WORKSPACE_ELEMENT_COMPLETE,
} from 'constants/workspaceOnboarding';

import { useGetSelectedWorkspace } from 'hooks/workspace';
import { useGetSelectedWorkspaceOnboarding } from 'hooks/workspaceOnboarding';

import { dismissElementHandler } from 'components/welcome-modal';

import styles from './styles.module.less';

const DashboardOnboardingCardCompact = props => {
  const {
    heading,
    description,
    primaryAction,
    centerpiece,
    cardKey,
    workspaceId,
  } = props;

  const dispatch = useDispatch();
  const [shouldFadeOut, setShouldFadeOut] = useState(false);
  const dismissable = cardKey !== RECORD_VIDEO_CARD_KEY;

  const onDismiss = () => {
    if (shouldFadeOut) {
      return;
    }

    setShouldFadeOut(true);
    setTimeout(() => {
      dismissElementHandler(dispatch, cardKey, workspaceId);
    }, 280);
  };

  return (
    <Container
      padding={3}
      radius="medium"
      width="100%"
      borderSide="all"
      backgroundColor="backgroundSecondary"
      className={classnames(
        styles.container,
        shouldFadeOut && styles.dashboardOnboardingCardCompletionFade
      )}
    >
      <div className={styles.cardContainer}>
        <Icon icon={centerpiece} size={7} color="orangeDark" />
        <div className={styles.contentWrapper}>
          <header>
            {heading && (
              <Text
                variant="title"
                htmlTag="h2"
                fontWeight="black"
                className="mb:small"
              >
                {heading}
              </Text>
            )}
            {description && <Text htmlTag="h3">{description}</Text>}
          </header>
          <div className={styles.actionsWrapper}>
            <div className={styles.btnWrapper}>{primaryAction}</div>
            {dismissable && (
              <TextButton onClick={onDismiss}>Dismiss</TextButton>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};

function DashboardOnboardingCard(props) {
  const { cardKey } = props;

  const cardStates = useGetSelectedWorkspaceOnboarding();
  const selectedWorkspace = useGetSelectedWorkspace();

  if (cardStates === undefined || selectedWorkspace === undefined) {
    return null;
  }

  const cardCompleted = cardStates[cardKey] === WORKSPACE_ELEMENT_COMPLETE;

  return (
    <DashboardOnboardingCardCompact
      complete={cardCompleted}
      workspaceId={selectedWorkspace.id}
      {...props}
    />
  );
}

export default DashboardOnboardingCard;
